'use client';
import { Icon } from '@/app_components/common/Icon';
// biome-ignore lint/performance/noNamespaceImport: library designed for namespace import
import * as Accordion from '@/app_components/ui/primitives/Accordion';
import type { LandingPageFaq } from '@/app_data/mock/ndrData';

interface NdrFaqProps {
  title?: string;
  faqs: LandingPageFaq[];
  className?: string;
}

export const NdrFaq = ({ faqs, title, className = '' }: NdrFaqProps) => {
  return (
    <section
      className={`w-full ${className}`}
      data-cy='ndr-faq-section'
    >
      <div className='lg:max-w-[var(--width-md)] lg:mx-auto layout-gap-md flex flex-col'>
        <h2
          className='typography-level-2 font-semibold text-neutral-900 text-center'
          data-cy='ndr-faq-title'
        >
          {title || 'Frequently Asked Questions'}
        </h2>

        <div className='flex flex-col gap-xl'>
          {faqs.map((faq, index) => (
            <Accordion.Root
              className='w-full'
              collapsible
              key={faq.question}
              type='single'
            >
              <Accordion.Item
                className='shadow-[0_4px_20px_0_rgba(0,0,0,0.04)] border-gray-200 rounded-md overflow-hidden'
                data-cy={`ndr-faq-item-${index}`}
                value={`item-${index}`}
              >
                <Accordion.Trigger className='w-[var(--width-md)] px-xs py-xs text-left bg-white flex items-center justify-between hover:text-neutral-700 transition-colors duration-200'>
                  <span
                    className='typography-level-5 font-medium pr-xs'
                    data-cy={`ndr-faq-question-${index}`}
                  >
                    {faq.question}
                  </span>
                  <Icon
                    className='group-data-[state=open]:rotate-180 flex-shrink-0 transition-transform duration-300 ease-in-out '
                    icon='ButtonDown'
                    size='sm'
                  />
                </Accordion.Trigger>
                <Accordion.Content
                  className='px-xs py-xs border-t border-neutral-200'
                  id={`faq-answer-${index}`}
                >
                  <p
                    className='text-base leading-relaxed'
                    data-cy={`ndr-faq-answer-${index}`}
                  >
                    {faq.answer}
                  </p>
                </Accordion.Content>
              </Accordion.Item>
            </Accordion.Root>
          ))}
        </div>
      </div>
    </section>
  );
};
